import { render, staticRenderFns } from "./couponTips.vue?vue&type=template&id=5561d0fa&scoped=true"
import script from "./couponTips.vue?vue&type=script&lang=js"
export * from "./couponTips.vue?vue&type=script&lang=js"
import style0 from "./couponTips.vue?vue&type=style&index=0&id=5561d0fa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5561d0fa",
  null
  
)

export default component.exports